<template>
  <base-nav v-model="showMenu" class="navbar-absolute top-navbar" type="white" :transparent="true">
    <div slot="brand" class="navbar-wrapper">
      <!-- Botón toggle sidebar: oculto en desktop (sidebar siempre mini con hover) -->
      <div class="navbar-minimize d-inline d-lg-none"><sidebar-toggle-button /></div>
      <!-- Botón hamburguesa: solo visible en tablet/móvil -->
      <div class="navbar-toggle d-inline d-lg-none" :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <div class="navbar-brand text-truncate">
        {{ routeName }} - {{ $SuscripcionesUsuarios.getEtiqueta() }}
      </div>

    </div>

    <audio ref="audioNotificacion" src="@/assets/audio/notificacion.mp3" preload="auto" id="audioNotificacion"
      muted></audio>
    <ul class="navbar-nav" :class="isRTL ? 'mr-auto' : 'ml-auto'">
      <!-- Buscador inline para desktop -->
      <li class="nav-item d-none d-lg-flex align-items-center">
        <div class="eclock-search-bar" @click="focusSearch">
          <i class="fas fa-search eclock-search-icon"></i>
          <input
            ref="searchDesktop"
            type="text"
            v-model="searchQuery"
            v-on:keyup.enter="OnBuscar"
            class="eclock-search-input"
            placeholder="Buscar personal"
          />
          <span class="eclock-search-shortcut">Ctrl+K</span>
        </div>
      </li>

      <!-- Buscador inline para móvil -->
      <div class="search-bar input-group d-lg-none">
        <input type="text" v-model="searchQuery" class="d-lg-none form-control" v-on:keyup.enter="OnBuscar"
          placeholder="Buscar..." />
        <div class="d-lg-none input-group-addon" @click="OnBuscar">
          <i class="fas fa-search"></i>
        </div>
      </div>

      <Tema />

      <base-dropdown style="max-width: 90vw;" v-if="LasNotificaciones" tag="li" :menu-on-right="!isRTL" title-tag="a" title-classes="nav-link"
        menu-classes="dropdown-black mx-0" class="nav-item">
        <template slot="title">
          <div :class="HayNotificacionClass"></div>
          <i class="fas fa-bell"></i>
          <p class="d-lg-none">Notificaciones</p>
        </template>
        <Main-Cargando :cargando="CargaNoti">
          <div style="max-height: 50vh; overflow-y: auto; width: auto;">
            <li style="width: auto;" class="" v-for="(notificaion, index) in LasNotificaciones" v-bind:key="notificaion.id">
              <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" />
            </li>
          </div>
          <!-- <div ref="ListNoti" :class="ScrollActive ? 'beauty-scroll' : 'noscroll'"
            style="max-height: 80vh; overflow-y: auto;" @scroll="actividad">
            <li class="nav-link" v-for="(notificaion, index) in LasNotificaciones" v-bind:key="notificaion.id">
              <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" />
            </li>
          </div> -->
        </Main-Cargando>
      </base-dropdown>

      <base-dropdown tag="li" :menu-on-right="!isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
        menu-classes="dropdown-black ">
        <template slot="title">
          <div class="photo"><img :src="FotoURL" /></div>
          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">{{ Nombre }}</p>
        </template>

        <li class="nav-link">
          <router-link to="/usuarios/perfil" class="nav-item dropdown-item text-white">
            <i class="fas fa-user"></i>
            Mi perfil
          </router-link>
        </li>
        <li class="nav-link">
          <router-link to="/usuarios/comentarios" href="#" class="nav-item dropdown-item text-white">
            <i class="fas fa-lightbulb"></i>
            Comentarios
          </router-link>
        </li>

        <li class="nav-link">
          <router-link to="/auditorias" href="#" class="nav-item dropdown-item text-white">
            <i class="fas fa-clipboard-list"></i>
            Auditoría
          </router-link>
        </li>
        <li class="nav-link">
          <a :href="soporteURL" target="_blank" class="nav-item dropdown-item text-white">
            <i class="fas fa-headset"></i>
            Soporte
          </a>
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link" v-for="suscripcionUsuario in SuscripcionesUsuario"
          v-bind:key="suscripcionUsuario.suscripcionID">
          <a href="#" class="nav-item dropdown-item text-white"
            @click="CambiaSuscripcion(suscripcionUsuario.suscripcionID)">
            {{ suscripcionUsuario.suscripcion.etiqueta }}({{
              ObtenEtiquetaPerfil(suscripcionUsuario.perfilID)
            }})
          </a>
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link">
          <router-link to="/logout" class="nav-item dropdown-item text-white">
            <i class="fas fa-sign-out-alt"></i>
            Cerrar sesión
          </router-link>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { BaseNav } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";
import Notificacion from "./Notificacion";
import swal from "sweetalert2";
import Tema from "@/Vistas/Main/Tema.comp.vue";

import Notificaciones from "@/api-services/notificaciones.service";
import Usuarios from "@/api-services/usuarios.service";
import SuscripcionesUsuarios from "@/api-services/suscripciones.usuarios.service";

export default {
  components: {
    SidebarToggleButton,
    BaseNav,
    Notificacion,
    Tema,
  },
  computed: {
    HayNotificacionClass() {
      if (this.LasNotificaciones && this.LasNotificaciones.length > 0)
        return " notification";
      return "";
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return false;
    },
  },
  props: {
    FotoURL: {
      type: String,
      default: "/img/default-avatar.png",
      description: "Contiene la url de la foto del usuario",
    },
    Nombre: {
      type: String,
      default: "El Usuario",
      description: "Contiene el nombre del usuario",
    },
    soporteURL: {
      type: String,
      default: "https://support.eclock.com.mx/portal/es/kb/eclock",
      description: "URL de Soporte Técnico",
    },
    SuscripcionesUsuario: Array,
  },
  data() {
    return {
      Obscuro: false,
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      LasNotificaciones: null,
      CargaNoti: false,
      ScrollActive: false,
      ScrollListener: null,
      Observer: null,
    };
  },
  watch: {
    LasNotificaciones(newVal, oldVal) {
      console.debug("Cambiaron las notificaciones")
      this.CargaNoti = true
      setTimeout(() => {
        this.CargaNoti = false
      }, 500);
    },
  },
  mounted() {
    this.Actualizar();
    // Global keyboard shortcut Ctrl+K / Cmd+K to focus search
    this._handleSearchShortcut = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        if (this.$refs.searchDesktop) {
          this.$refs.searchDesktop.focus();
        }
      }
    };
    document.addEventListener('keydown', this._handleSearchShortcut);
    let notifilis = this.$refs.ListNoti.focus();
    const options = {
      root: null, 
      rootMargin: '0px', 
      threshold: 0.5, 
    };
    this.Observer = new IntersectionObserver(this.callback, options);
    this.Observer.observe(notifilis);

  },
  methods: {
    actividad(event) {
      this.ScrollActive = true
      clearTimeout(this.ScrollListener)
      this.ScrollListener = setTimeout(() => {
        this.ScrollActive = false
      }, 1000);
    },
    callback(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.ListNoti.focus()
        } else {
          this.$refs.ListNoti.blur()
        }
      });
    },
    ObtenEtiquetaPerfil(PerfilID) {
      return SuscripcionesUsuarios.ObtenEtiquetaPerfil(PerfilID);
    },
    Actualiza(comp) {
      console.debug("Si estoy actualizando")
      var Yo = this;
      this.CargaNoti = true
      Notificaciones.Actualiza(comp, (LasNotificaciones, Sonido) => {
        console.debug(LasNotificaciones);
        Yo.LasNotificaciones = LasNotificaciones;
        setTimeout(() => {
          this.CargaNoti = false
          Yo.LasNotificaciones = LasNotificaciones;
        }, 500);
      })
    },
    Actualizar() {
      console.debug("Si estoy actualizando");
      var Yo = this;
      Notificaciones.Obten(this, (LasNotificaciones, Sonido) => {
        console.debug(LasNotificaciones);
        console.debug(Sonido);
        Yo.LasNotificaciones = LasNotificaciones;
        if (Sonido) {
          let audio = Yo.$refs.audioNotificacion;
          audio.play();
        }
      });
    },
    OnActualizar(Dato) {
      console.debug(Dato);
      this.Actualizar();
    },
    OnBuscar() {
      this.$router.push({ path: "/personal", query: { b: this.searchQuery } });
      this.searchQuery = "";
      this.showMenu = false;
    },
    CambiaSuscripcion(SuscripcionID) {
      console.debug(SuscripcionID);
      SuscripcionesUsuarios.setSuscripcionID(SuscripcionID);
      Usuarios.getPerfilLocal((UsuarioPerfil) => { }, true);
      swal
        .fire({
          title: "Listo",
          text: "Se ha cambiado la suscripción seleccionada.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-fill",
          },
          buttonsStyling: false,
        })
        .then(() => {
          // this.$router.push({ path: '/' });
          window.location.reload(false);
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    focusSearch() {
      if (this.$refs.searchDesktop) {
        this.$refs.searchDesktop.focus();
      }
    },
  },
  beforeDestroy() {
    if (this._handleSearchShortcut) {
      document.removeEventListener('keydown', this._handleSearchShortcut);
    }
  },
};
</script>
<style lang="scss" scoped >
.top-navbar {
  top: 0px;
}

/* --- Navbar icon alignment --- */
.navbar-nav {
  display: flex !important;
  align-items: center !important;
  gap: 4px;
}

::v-deep .nav-item {
  display: flex;
  align-items: center;
}

::v-deep .nav-link {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  font-size: 1.1rem;
}

::v-deep .nav-item .fas {
  font-size: 1.05rem;
  line-height: 1;
}

/* Photo avatar in dropdown */
::v-deep .photo {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.beauty-scroll::-webkit-scrollbar {
  width: 10px !important;
  height: 4px !important;
}

.beauty-scroll::-webkit-scrollbar-track {
  background-color: transparent !important;
}

.beauty-scroll::-webkit-scrollbar-thumb {
  background-color: black !important;
  border-radius: 100px !important;
}

.noscroll::-webkit-scrollbar {
  width: 1px !important;
  height: 4px !important;
}

.noscroll::-webkit-scrollbar-track {
  background-color: transparent !important;
}

.noscroll::-webkit-scrollbar-thumb {
  background-color: transparent !important;
  border-radius: 100px !important;
  transition: all 0.9s linear !important;
}
</style>
